import { render, staticRenderFns } from "./PorAutor.vue?vue&type=template&id=eccbc8ce&scoped=true"
import script from "./PorAutor.vue?vue&type=script&lang=js"
export * from "./PorAutor.vue?vue&type=script&lang=js"
import style0 from "./PorAutor.vue?vue&type=style&index=0&id=eccbc8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccbc8ce",
  null
  
)

export default component.exports